export default __webpack_public_path__ + "static/media/Consultant-will-start-working-on-your-issues.a68a4f23.png";